import React from "react";

export const BlankPage = () => {
    return (
        <></>
    )
}